export enum CatalogPageActionUiEnum {
  ADD_FOLDER = 'ADD_FOLDER',
  PROJECT = 'PROJECT',
  ADD_PROJECT = 'ADD_PROJECT',
  IMPORT_PROJECT = 'IMPORT_PROJECT',
  IMPORT_RISE = 'IMPORT_RISE',
  ADD_PROJECT_MARKDOWN = 'ADD_PROJECT_MARKDOWN',
  ADD_PROJECT_AI = 'ADD_PROJECT_AI',
}

export enum CatalogTableActionUiEnum {
  UPDATE = 'UPDATE',
  MOVE = 'MOVE',
  DELETE = 'DELETE',
  DUPLICATE = 'DUPLICATE',
  COPY_IN_OTHER_COMPANY = 'COPY_IN_OTHER_COMPANY',
}
